import { apiCall, apiCallAdmin } from "../../services/api-service.js";

export const getcheckAPi = async (data) => {
  const response = await apiCall("GET", `scan?transaction_id=${encodeURIComponent(data ?? "")}`);
  return response.data;
};
export const getbasicDetAPi = async () => {
  const response = await apiCallAdmin("GET", `basicprofile`);
  return response.data;
};

export const getOrgLogoApi = async () => {
  const response = await apiCallAdmin("GET", `get_org_image`);
  return response.data;
};

export const updateProfileImageApi = async (data) => {
  return await apiCallAdmin("POST", `user/image_update`, data);
};
export const getOrgListApi = async () => {
  return await apiCallAdmin("GET", `get_enrolled_orgs`);
};

export const getSwitchAccountApi = async (id) => {
  return await apiCallAdmin("GET", `switch_org_http_only/${id}`);
};
